import axios from 'axios';

const API_BASE_URL = '/api/sub-specialities';

const subSpecialitiesService = {
  // Get all sub specialities with pagination, search, and filter
  getAll: async (params = {}) => {
    try {
      const response = await axios.get(API_BASE_URL, {
        params,
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Failed to fetch sub specialities' };
    }
  },

  // Get sub speciality by ID
  getById: async (id) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/${id}`, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Failed to fetch sub speciality' };
    }
  },

  // Create new sub speciality
  create: async (data) => {
    try {
      const response = await axios.post(API_BASE_URL, data, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Failed to create sub speciality' };
    }
  },

  // Update sub speciality
  update: async (id, data) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/${id}`, data, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Failed to update sub speciality' };
    }
  },

  // Delete sub speciality
  delete: async (id) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${id}`, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Failed to delete sub speciality' };
    }
  }
};

export default subSpecialitiesService;
